import Nullstack from 'nullstack';
export default function IconFold({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-fold",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v6l3 -3m-6 0l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M12 21v-6l3 3m-6 0l3 -3"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "12",
    x2: "5",
    y2: "12"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "12",
    x2: "10",
    y2: "12"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "12",
    x2: "15",
    y2: "12"
  }), "   ", Nullstack.element("line", {
    x1: "19",
    y1: "12",
    x2: "20",
    y2: "12"
  }), " ");
}